import { useContext } from 'react';
import { UpdateProjectDatesModalContext } from '../../dashboard/my-projects/Modals/UpdateProjectDatesModal';
import { Icon, Button } from '@platform/components';

type ProjectDatesSectionProps = {
  projectId: number;
  allowDateEdit: boolean;
  startDate?: string;
  endDate?: string;
};

export const ProjectDatesSection = ({
  projectId,
  allowDateEdit,
  startDate,
  endDate,
}: ProjectDatesSectionProps) => {
  const { openUpdateProjectDatesModal } = useContext(UpdateProjectDatesModalContext);
  return (
    <div className='flex gap-4 text-sm items-center'>
      {startDate && (
        <div className='flex'>
          <Icon type='flag-06' size='18' additionalClassNames='mr-0 md:mr-1 hidden md:block' />
          <div className='mr-2'>Start:</div>
          <div>{new Date(startDate).toLocaleDateString()}</div>
        </div>
      )}
      {endDate && (
        <div className='flex'>
          <Icon type='trophy-01' size='18' additionalClassNames='mr-0 md:mr-1 hidden md:block' />
          <div className='mr-2'>End:</div>
          <div>{new Date(endDate).toLocaleDateString()}</div>
        </div>
      )}
      {allowDateEdit && (
        // our IconButton component is a mess
        <Button
          size='sm'
          variant='secondary-color'
          onPress={() => {
            openUpdateProjectDatesModal({
              startDate: startDate ? new Date(startDate) : new Date(),
              endDate: endDate ? new Date(endDate) : new Date(),
              id: projectId,
            });
          }}
        >
          <Icon type='edit-05' size='18' />
        </Button>
      )}
    </div>
  );
};
